export default "__VITE_ASSET__kETMVGzH__"